module.exports = __webpack_public_path__ + "static/media/6-_DSC8909.c2df8bc4.jpg";